var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              staticClass: "modal_medium",
              attrs: { persistent: "" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: {
                        method: "post",
                        enctype: "multipart/form-data",
                        "lazy-validation": "",
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("v-card-title", [
                        _c("span", { staticClass: "headl" }, [
                          _vm._v("TOMA DE LECTURA"),
                        ]),
                      ]),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-container",
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", sm: "12", md: "12" },
                                    },
                                    [
                                      _vm.getTakeRead.length > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "ctn_take_read" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "take_read_colum",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "copy_read_colum",
                                                    },
                                                    [
                                                      _c("h2", [
                                                        _vm._v(
                                                          "ULTIMA LECTURA"
                                                        ),
                                                      ]),
                                                      _c(
                                                        "p",
                                                        { staticClass: "day" },
                                                        [
                                                          _vm.data.switch ==
                                                          true
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "lbs sw_active",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.data
                                                                        .switch ==
                                                                        true
                                                                        ? "Encendido"
                                                                        : "Apagado"
                                                                    )
                                                                  ),
                                                                ]
                                                              )
                                                            : _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "lbs sw_inactive",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.data
                                                                        .switch ==
                                                                        true
                                                                        ? "Encendido"
                                                                        : "Apagado"
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "take_read_colum",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "copy_read_colum",
                                                    },
                                                    [
                                                      _c("h3", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.getTakeRead
                                                                .usage
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDateFrom"
                                                            )(
                                                              _vm.getTakeRead
                                                                .dateNow
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _c("v-col", {
                                    attrs: { cols: "12", sm: "12", md: "12" },
                                  }),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-text-field", {
                                        ref: "nui",
                                        attrs: {
                                          rules: _vm.nameRules,
                                          label: "NUI",
                                          required: "",
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.data.nui,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.data, "nui", $$v)
                                          },
                                          expression: "data.nui",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-text-field", {
                                        ref: "idx",
                                        attrs: { label: "IDX", disabled: "" },
                                        model: {
                                          value: _vm.data.idx,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.data, "idx", $$v)
                                          },
                                          expression: "data.idx",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-select", {
                                        ref: "profile",
                                        attrs: {
                                          items: ["post", "pre"],
                                          label: "Perfil",
                                          rules: _vm.fieldRules,
                                          disabled: "",
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "selection",
                                            fn: function ({ item }) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item == "post"
                                                        ? "Postpago"
                                                        : "Prepago"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "item",
                                            fn: function ({ item }) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      item == "post"
                                                        ? "Postpago"
                                                        : "Prepago"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                        model: {
                                          value: _vm.data.profile,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.data, "profile", $$v)
                                          },
                                          expression: "data.profile",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("v-select", {
                                        ref: "subTypeService",
                                        attrs: {
                                          items: ["Agua", "Gas", "Energia"],
                                          label: "Tipo",
                                          rules: _vm.fieldRules,
                                          disabled: "",
                                        },
                                        model: {
                                          value: _vm.data.subTypeService,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.data,
                                              "subTypeService",
                                              $$v
                                            )
                                          },
                                          expression: "data.subTypeService",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "colm_custom",
                                      attrs: { cols: "6", sm: "12", md: "6" },
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "min-width": "auto",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          ref: "date-init",
                                                          attrs: {
                                                            label:
                                                              "Fecha Inicial",
                                                            "prepend-icon":
                                                              "mdi-calendar",
                                                            rules:
                                                              _vm.nameRules,
                                                            disabled:
                                                              _vm.isMassive,
                                                            readonly: "",
                                                            required: "",
                                                          },
                                                          model: {
                                                            value: _vm.dateIni,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.dateIni = $$v
                                                            },
                                                            expression:
                                                              "dateIni",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                          model: {
                                            value: _vm.datePicker1,
                                            callback: function ($$v) {
                                              _vm.datePicker1 = $$v
                                            },
                                            expression: "datePicker1",
                                          },
                                        },
                                        [
                                          _c("v-date-picker", {
                                            ref: "date-init",
                                            attrs: {
                                              max: new Date()
                                                .toISOString()
                                                .substr(0, 10),
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.datePicker1 = false
                                              },
                                            },
                                            model: {
                                              value: _vm.dateIni,
                                              callback: function ($$v) {
                                                _vm.dateIni = $$v
                                              },
                                              expression: "dateIni",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "colm_custom",
                                      attrs: { cols: "6", sm: "12", md: "6" },
                                    },
                                    [
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: {
                                            "close-on-content-click": false,
                                            "nudge-right": 40,
                                            transition: "scale-transition",
                                            "offset-y": "",
                                            "min-width": "auto",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on, attrs }) {
                                                return [
                                                  _c(
                                                    "v-text-field",
                                                    _vm._g(
                                                      _vm._b(
                                                        {
                                                          ref: "date-dateEnd",
                                                          attrs: {
                                                            label:
                                                              "Fecha Final",
                                                            "prepend-icon":
                                                              "mdi-calendar",
                                                            rules:
                                                              _vm.nameRules,
                                                            disabled:
                                                              _vm.isMassive,
                                                            readonly: "",
                                                            required: "",
                                                          },
                                                          model: {
                                                            value: _vm.dateEnd,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.dateEnd = $$v
                                                            },
                                                            expression:
                                                              "dateEnd",
                                                          },
                                                        },
                                                        "v-text-field",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    )
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                          model: {
                                            value: _vm.datePicker2,
                                            callback: function ($$v) {
                                              _vm.datePicker2 = $$v
                                            },
                                            expression: "datePicker2",
                                          },
                                        },
                                        [
                                          _c("v-date-picker", {
                                            ref: "date-dateEnd",
                                            attrs: {
                                              min: new Date(_vm.dateIni)
                                                .toISOString()
                                                .substr(0, 10),
                                              max: new Date()
                                                .toISOString()
                                                .substr(0, 10),
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.datePicker2 = false
                                              },
                                            },
                                            model: {
                                              value: _vm.dateEnd,
                                              callback: function ($$v) {
                                                _vm.dateEnd = $$v
                                              },
                                              expression: "dateEnd",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "6", sm: "12", md: "6" } },
                                    [
                                      _c("v-autocomplete", {
                                        ref: "period",
                                        attrs: {
                                          items: _vm.periodSelect,
                                          "search-input": _vm.searchPeriod,
                                          rules: _vm.nameRules,
                                          disabled: _vm.isMassive,
                                          "item-value": "_id",
                                          "item-text": "name",
                                          label: "Periodo",
                                          placeholder: "Selecciona el periodo",
                                          clearable: "",
                                        },
                                        on: {
                                          "update:searchInput": function (
                                            $event
                                          ) {
                                            _vm.searchPeriod = $event
                                          },
                                          "update:search-input": function (
                                            $event
                                          ) {
                                            _vm.searchPeriod = $event
                                          },
                                        },
                                        model: {
                                          value: _vm.form.period,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "period", $$v)
                                          },
                                          expression: "form.period",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _c(
                            "div",
                            { staticClass: "ctn_btn_shop" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { large: "", text: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.show = false
                                    },
                                  },
                                },
                                [_vm._v("Cerrar")]
                              ),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    depressed: "",
                                    large: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.validate },
                                },
                                [_vm._v("TOMAR LECTURA")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }